<template>
  <div class="addNewClass">
    <div class="content">
      <div class="header" style="font-size:18px;margin-bottom: 10px">
        赠品规则设置 :
      </div>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" bg-purple name">
            <span>加油额度</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="flex">
            <el-input
              v-model="num"
              type="number"
              class="radioInputM"
              size="small"
            ></el-input>
            <div class="marginRL">至</div>
            <el-input
              v-model="num"
              type="number"
              class="radioInputM"
              size="small"
            ></el-input>
            <div class="marginRL">元</div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" bg-purple name">
            <span>赠送礼品选择</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="20">
          <div class=" bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="10">
                <div class="flex">
                  <div
                    class="product"
                    v-for="(item, index) in products"
                    :key="index"
                    ref="child"
                    @click="condition(0, index)"
                  >
                    {{ item.title }}
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40" v-show="choseProduct.length != 0">
        <el-col :span="3">
          <div class=" bg-purple name">
            <span>赠送方式</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="20">
          <div class=" bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="10">
                <el-radio-group v-model="radio">
                  <el-radio
                    v-show="index != 0"
                    :label="index + ''"
                    v-for="(item, index) in choseProduct"
                    :key="index"
                  >
                    <span>{{ choseProduct.length }}选{{ index }}</span>
                  </el-radio>
                  <el-radio label="0">
                    全选
                  </el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40" v-show="choseProduct.length != 0">
        <el-col :span="3">
          <div class=" bg-purple name">
            <span>赠送数量</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="20">
          <div class=" bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="10">
                <div
                  class="flex"
                  v-for="(item, index) in choseProduct"
                  :key="index"
                >
                  <div class="choseProduct">{{ item.title }}</div>
                  <input
                    v-model="num"
                    type="number"
                    class="radioInputM"
                    size="small"
                  />
                  <div class="marginRL">个</div>
                  <div class="marginRL delColor" @click="condition(1, index)">
                    删除
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class=" bg-purple name">
            <span>赠送协议</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="20">
          <div class=" bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="10">
                <el-input type="textarea"></el-input>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40" class="marginSX" style="margin-top: 40px;">
        <el-col :span="5" :offset="2">
          <div class="grid-content">
            <el-button size="small">取消</el-button>
            <el-button size="small" type="primary">发布</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { addCoupon, editcoupon, detailcoupon } from "@/api/coupon";
import { vipList } from "@/api/vip";
import { getCateApi, addImage } from "@/api/mall";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  components: {},
  data() {
    return {
      num: "",
      radio: "0",
      products: [
        {
          title: "小礼盒",
          index: "0"
        },
        {
          title: "公仔",
          index: "1"
        },
        {
          title: "挂件",
          index: "2"
        },
        {
          title: "xiixi",
          index: "3"
        },
        {
          title: "神秘大礼包",
          index: "4"
        }
      ],
      choseProduct: []
    };
  },
  methods: {
    condition(type, index) {
      console.log("sss", type, index);
      if (type == 0) {
        var jude = this.choseProduct.some(item => {
          return item.index == index;
        });
        if (jude) {
          this.$message("该赠品已经存在，请勿重复添加！！");
          return false;
        }
        this.$refs.child[index].style =
          "color: #409EFF; border: 1px solid #409EFF";
        this.choseProduct.push(this.products[index]);
      } else {
        var id = this.choseProduct[index].index;
        this.$refs.child[id].style = "border: 1px solid #e5e5e5;color: #666;";
        this.choseProduct.splice(index, 1);
      }

      // this.choseShow = "mehtodsButton choseButton";
    }
  }
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
}
.color {
  color: #606266;
  font-size: 10px;
}
.delColor {
  color: #f56c6c;
  cursor: pointer;
}
.product {
  height: 32px;
  line-height: 32px;
  width: 100px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  margin: 0 10px 10px 0;
  cursor: pointer;
}
.choseProduct {
  height: 32px;
  line-height: 32px;
  width: 100px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  margin-right: 10px;
}
.radioInputM {
  height: 28px;
  margin-right: 5px;
  width: 60px;
}
.marginR {
  margin-right: 5px;
}
.marginRL {
  margin: 0 5px;
}
.marginSX {
  margin: 10px 0;
}
.addNewClass {
  height: 100%;
  position: relative;
  .content {
    position: absolute;
    overflow: auto;
    border-top: 1px solid #f1f1f1;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 20px 30px;
    .operation {
      height: 50px;
    }
    .el-row {
      margin-top: 15px;
      font-size: 14px;
    }

    .labelsort {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .name {
      text-align: right;
    }
    .rgt {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .img {
    width: 80px;
    height: 80px;
    background: #ff00004f;
  }
}
</style>
